import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.mandant-id';
import * as api from '../../../clients/api';

@Injectable()
export class ApiMandantIdEffects {

    MandantId$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_MANDANT_ID),
        mergeMap((x: ac.GetMandantIdAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getMandantId().pipe(
                map((result: any) => {
                    return new ac.GetMandantIdErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetMandantIdFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.ApiService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.ApiService {
        if (this.service === null) {
            this.service = this.injector.get(api.ApiService);
        }
        return this.service;
    }
}
